import { Pipe, PipeTransform } from '@angular/core';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { DateTime } from 'luxon';
import { FormatDateTimePipe } from 'src/shared/pipes/format-date-time.pipe';

@Pipe({
    name: 'formatDateTitle',
    standalone: false
})
export class FormatDateTitlePipe implements PipeTransform {

  constructor() {}

  transform(value: string) {
    const today = DateTime.now();
    const tomorrow = today.plus({ days: 1 });
    const date = value.includes('T') ? DateTime.fromISO(value) : DateTime.fromFormat(value, 'yyyy-MM-dd');
    const formatedDate = new FormatDateTimePipe().transform(value, 'LLL d');
    if (today.hasSame(date, 'day')) {
      return (new TranslationPipe().transform('Today')) + ' ' + formatedDate;
    }
    if (tomorrow.hasSame(date, 'day')) {
      return (new TranslationPipe().transform('Tomorrow')) + ' ' + formatedDate;
    }
    const weekDay = date.weekdayLong;
    return (new TranslationPipe().transform(weekDay)) + ' ' + formatedDate;
  }

}
